var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 43,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.0232558)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 43,
    height: 43,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAArCAYAAADhXXHAAAAETElEQVRYCe2ZW4gcRRSGazfxhgqiM9Pn/7tXB1wvLL4IIiLoi0EUFW94jeJTCDGIoKCCoIIgig+++SDe8IKiqIiIT4oYUSRiEFQCXkDFy0PUh0S8ZFflH+sMldma3Z7J9DpCGorqPn3q1NfVdU5Vnw5hyNHpdAqSt5F8H8AigL/XoHwJ4BEAZw3BWi4GcAuAn9YAbugAmNlzJOeW0yUSAM8kkEsAPgRwr5ldYWYXNFEAXApgM4BXAOxJ+v8BwHEJ3r+nCwsLB5N8IlH8muRFIYR1y5QbFFRVNa9RdQ6S35dleeI+XZK8KVF4syzLY/ZRWOMLTUWSf0am7f1BK4qi46AAvgkhrF9jtmx3JB90LjO7tadE8kkXAjg727KmsCiKU2QYwH1FUVwYQjioZtOsGoDfI9tiINki+UUU7AghzGZb1RCa2V0A/kgeXN6+TW+uRvOsipltdXuCPRXArxKQvCfbooaQ5JluFICiyG6/luPWMJFVabfb5nYEuyFeLJG8JtuihhDAS9HOopmd3mq1jiT5Vr+jGjZyKt1u9ygAX8lOAHCeTuR5MVTl2qwqA/CR7JjZx64MYFMCO5bT6qFlc9KwTzuYmV1J8iQAn7rMH2DUuhHYCJddPs3sgVEhXb8RWBkHcB2AXT6asX6q3W4f4Z2PWjcGKxA5BMlrFXIUc0eFG9RvFHaws/29bgp2huTFcXupLebNAE6bOtiqqg4D8MbAXO05G8kXNDrjQk98ZEnenoDqq2IvgL8S2UPTArsOwNsCM7P35GBzc3OsquoEAJ848LTAzpJ8LULtrKrqaAczsxsS2OlYwUheHV+95umzDgvgcoftdruHunyUeuJzVp0D2BnBPnCY+BA9Rxt3X9sU7HbB6tP9/wC7Q7BysgOwE97PHhjZphzMvxSGzdnpiLMxdPVgAfRDF4CNHmfHzUVMfGTNbAHAzxHsHY8G6aIA4E6Xj1JPGnbWzJ6PMVYfnVc5TFEUhyc5iV0kT/Z7dessrJZLkpfUNZLorQegvKpWqpcTee+0LMtzPKtC8tzB+6tdC9Y3RMobKDmhpIQC+tbVGmfua9f1bmz/uZndrw9ELwBejMno34qiOCPTfkWRMkYAfpH90Ol0jgfwoy60UQ4hzKzYOnNTrz7J+PX2ArI3UF7vZwIzNoaJ0kxPT0f5KDecbvGGGcjJAVwfNzN6cCWBe8XMvgPw6Dig6kfLt7M57GUuUOY7B1NTNqOk9Pz8/CFexg1Z6i/Od39D2/oMPu8i9Kb+jf/oxMy6ieMukjy2j9JqaR7j2wi7FLMoY606faNjnmhElZ6PLHvNbMsyX1JSIgnuig7y7i3xr8l+JYVX4Z6JyZENZvZq+iuL5B1D2ypwA/gsmcOaM3oNelLF0yaK3mj6l0Z97qkVSvW9ZGY3amQHoH2yN1nvNrPH9Ndm6Ijmbsizzex8M7ub5MNm9ngTRX8V48+OzSul9P8BgPK9BJi1UnEAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.499f720a9e16ec120155eda76d8e1519.svg";
export { ForwardRef as ReactComponent };